module.exports = __webpack_public_path__ + "static/media/ajax-Loader_es.d1403647.gif";